import { ref, computed } from '@vue/composition-api';
import { formatCurrency as formatCurrencyDisplay } from '../components/Utils.js';

export function useMarketSignalPanel({ dailyDigest, loading }) {
  // Highlight animation state
  const showHighlight = ref(false);

  /**
   * Market signals from daily digest data.
   * Computed property that extracts market_patterns from the daily digest.
   * @returns {Array} Array of market signal objects, or empty array if none available
   */
  const marketSignals = computed(() => {
    return dailyDigest.value?.market_patterns || [];
  });

  /**
   * Formats a numeric value as currency using the formatCurrencyDisplay utility.
   * @param {number} value - The numeric value to format
   * @returns {string} Formatted currency string (e.g., "$1.5M", "$5.2K", "$1,234")
   */
  const formatCurrency = (value) => {
    return formatCurrencyDisplay(value);
  };

  /**
   * Triggers highlight animation on market signals panel.
   * @param {number} duration - Duration in milliseconds (default: 1500)
   */
  const triggerHighlight = (duration = 1500) => {
    showHighlight.value = true;
    setTimeout(() => {
      showHighlight.value = false;
    }, duration);
  };

  return {
    // Data
    marketSignals,
    loading,
    // Highlight
    showHighlight,
    triggerHighlight,
    // Formatting
    formatCurrency
  };
}